import {Box} from '@mui/material';
import {useRef} from 'react';
import CollectionSelection from './CollectionSelection.tsx';
import ConfigurationSelection from './ConfigurationSelection.tsx';
import Highlights from './Highlights.tsx';
import VisualizeButton from './VisualizeButton.tsx';
import {useGetConfigurations} from '@src/api/configurations.ts';
import dimensions from '@src/styles/dimensions.ts';

export const Browse = () => {
  const configurationChangedRef = useRef(false);
  const {isLoading: isLoadingConfigurations} = useGetConfigurations();

  return (
    <>
      <ConfigurationSelection changedRef={configurationChangedRef} />
      <Box
        sx={{
          flexGrow: 1,
          overflowBlock: 'auto',
          display: 'flex',
          flexDirection: 'column',
          marginInline: `-${dimensions.leftSidebar.contentMargin}px`,
        }}
      >
        {!isLoadingConfigurations && <CollectionSelection />}
        <VisualizeButton />
        <Highlights />
      </Box>
    </>
  );
};

export default Browse;
